export default __webpack_public_path__ + "static/media/RobotoSlab-Light.c7371947.woff";